export default "icons-text-italic"